import * as angular from 'angular';

angular
	.module('app')
	.filter('capitalize', utility => input =>
		angular.isString(input) && input.length > 0 ? utility.capitalize(input) : input
	);
